/**
 * Telemetry event-name catalog for the new ticket dashboard & admin view surfaces.
 *
 * Mirrors the dotted `Domain.EventName` convention of the wizard's
 * `TelemetryConstants` (see `app/utils/constants`). Kept co-located with the
 * view module so the view-side events stay additive and discoverable. These map
 * to the PRD telemetry events for the view surfaces and are emitted through the
 * shared `logFlowEvent` helper.
 */
export const ViewTelemetryConstants = {
    /** #1 — ticket detail opened (customerCount, isMultiCustomer, requestType, role). */
    TICKET_DETAIL_LOADED: 'View.TicketDetailLoaded',
    /** #2 — inline Add Customer drawer opened. */
    ADD_CUSTOMER_DRAWER_OPENED: 'View.AddCustomerDrawerOpened',
    /** #3 — a customer/opportunity was appended to a ticket. */
    CUSTOMER_ADDED: 'View.CustomerAdded',
    /** #4 — grouped MSX search failed inside the drawer. */
    MSX_SEARCH_FAILED: 'View.MsxSearchFailed',
    /** #5 — a customer was removed from a ticket. */
    CUSTOMER_REMOVED: 'View.CustomerRemoved',
    CUSTOMER_REMOVE_FAILED: 'View.CustomerRemoveFailed',
    /** #6 — the remove-customer confirm dialog was dismissed/cancelled. */
    REMOVE_DIALOG_DISMISSED: 'View.RemoveDialogDismissed',
    /** #7 — success toast shown after an append. */
    ADD_CUSTOMER_SUCCEEDED_TOAST: 'View.AddCustomerSucceededToast',
    /** #8 — which contextual-details variant was rendered (requestType). */
    CONTEXTUAL_DETAILS_VARIANT: 'View.ContextualDetailsVariant',
    /** #9 — confidential identifier section rendered for an authorized detail caller. */
    CONFIDENTIAL_IDENTIFIER_VIEWED: 'View.ConfidentialIdentifierViewed',
} as const;

/** Union of the view-surface telemetry event names. */
export type ViewTelemetryEvent =
    typeof ViewTelemetryConstants[keyof typeof ViewTelemetryConstants];

/** Section tag passed to `logFlowEvent` for all view-surface events. */
export const VIEW_TELEMETRY_SECTION = 'Dashboard & Admin View' as const;
